import { ToastContainer } from 'react-toastify'
import './App.css'
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './Routes'

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
